











import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({
  components: {
    // Location: () => import('@/components/base/InsLocation.vue')
    InsPhotoGallery: () => import('@/components/business/cms/InsPhotoGallery.vue'),
    InsHomeRnp: () => import('@/components/business/home/InsHomeRNP.vue')
  }
})
export default class InsCmsContent extends Vue {
  CateName: string = '';
  content: any={};
  hasPhotoGallery: boolean = false; // 是否有图片集功能
  photos: object[] = [];

  // 获取关于我们cms内容
  getContent () {
    this.hasPhotoGallery = false;
    this.$Api.cms.getContentByDevice({ ContentId: this.id, IsMobile: this.isMobile }).then(result => {
      this.content = result.CMS;
      this.CateName = result.CMS.Name;

      this.$nextTick(() => {
        if (result.CMS.Title) document.title = result.CMS.Title;
      });

      for (let i = 0; i < this.content.CmsControl.length; i++) {
        if (this.content.CmsControl[i].ControlId === 'd765d5eb-da01-49ad-b1f8-31072b980b83') {
          this.hasPhotoGallery = true;
          this.photos = this.content.CmsControl[i].ControlImageLis;
          break;
        }
      }
      // this.$HiddenLayer();
    });
  }

  checkPhotos () {

  }

  get id () {
    return this.$route.params.id;
  }

  get isMobile () {
    return this.$store.state.isMobile;
  }

  created () {
    if ((window as any).__PRERENDER_INJECTED) {
      try {
        let seoData = require('../../sdk/common/SeoData');
        let keywords = document.createElement('meta');
        keywords.setAttribute('name', 'keywords');
        keywords.setAttribute('content', seoData.seoItem['cms' + this.id].keyword);
        document.head.appendChild(keywords);
        let description = document.createElement('meta');
        description.setAttribute('name', 'description');
        description.setAttribute('content', seoData.seoItem['cms' + this.id].description);
        document.head.appendChild(description);
        document.title = seoData.seoItem['cms' + this.id].title;
        document.dispatchEvent(new Event('render-event'));
      } catch (e) {
        console.log('當前頁面無需SEO。');
      }
    }
  }

  mounted () {
    this.getContent();
    this.checkPhotos();
  }

  @Watch('isMobile', { deep: true })
  onMediaChange () {
    this.getContent();
  }

  @Watch('id', { deep: true })
  onKeyChange () {
    this.content = {};
    this.getContent();
  }
}
